// extracted by mini-css-extract-plugin
export default {"question":"merge-question-list_question__YVWlj","question-input":"merge-question-list_question-input__hDOLR"};